import React from 'react';
import { CSSProperties } from 'react';


const customStyles: CSSProperties = {
  ['--select-button-svg' as string]: "url('data:image/svg+xml...",
  fontFamily: '"Public Sans", "Noto Sans", sans-serif'
};
const Statements: React.FC = () => {
  return (<div> Approved Requests</div>)}

export default Statements;